import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { validateUSPhoneNumber } from '@linqpal/models/src/helpers/validations'
import { useEditorModel } from '../../useEditorModel'
import { Spacer } from '../../../../../ui/atoms'
import { BtPhoneInput } from '@linqpal/components/src/ui/BtPhoneInput'
import { CompProps } from '../../Editor'

export const PhoneInput: React.FC<
  CompProps & { testID?: string; label: string }
> = ({ doc, group, item, onValueUpdate, testID, label }) => {
  const { t } = useTranslation('application')

  const validateInput = useCallback(
    (value: string) =>
      validateUSPhoneNumber(value) ? '' : t('ValidationErrors.InvalidPhone'),
    [t],
  )

  const validateEditorValue = useCallback((value: string | null) => {
    return validateUSPhoneNumber(value || '')
  }, [])

  const model = useEditorModel(
    doc,
    group,
    item,
    onValueUpdate,
    '',
    validateEditorValue,
  )

  const onChange = (value) => {
    model.setValue(item, value.parsed)
  }

  return (
    <>
      <Spacer height={22} />
      <BtPhoneInput
        value={model.value}
        testID={testID}
        label={t(label as unknown as TemplateStringsArray)}
        validate={validateInput}
        onChangeText={onChange}
      />
    </>
  )
}
